import type { InstagramEmbedBlock as InstagramEmbedBlockType } from '@/payload-types'
import type { SerializedBlockNode } from '@payloadcms/richtext-lexical'
import type { JSXConverter } from '@payloadcms/richtext-lexical/react'
import InstagramEmbedBlock from '../blocks/InstagramEmbedBlock'
import ContentBlockWrapper from '../molecules/ContentBlockWrapper'

export const InstagramEmbedConverter: JSXConverter<
	SerializedBlockNode<InstagramEmbedBlockType>
> = ({ node }) => {
	const { embedCode, embedScript } = node.fields

	return (
		<ContentBlockWrapper blockTypes={['component']}>
			<div className="col-span-full">
				<InstagramEmbedBlock embedCode={embedCode} embedScript={embedScript} />
			</div>
		</ContentBlockWrapper>
	)
}
